<template>
  <div class="mobilePageB" :class="{ ios: os.isPhone }">
    <div class="pageB">
      <div class="header">
        <img src="@/assets/images/mobile1/pageB/logo.png" alt="" class="logo" />
        <div class="contactBox">
          <img
            v-if="swUrl"
            src="@/assets/images/mobile1/pageB/business.png"
            class="contactItem"
            @click="toPage(swUrl)"
          />
          <img
            v-if="tgUrl"
            src="@/assets/images/mobile1/pageB/official.png"
            class="contactItem"
            @click="toPage(tgUrl)"
          />
          <img
            v-if="qdUrl"
            src="@/assets/images/mobile1/pageB/channel.png"
            class="contactItem"
            @click="toPage(qdUrl)"
          />
        </div>
      </div>

      <img
        src="@/assets/images/mobile1/pageB/slogan.webp"
        alt=""
        class="slogan"
      />

      <div class="bottomBox">
        <div class="btnGroup">
          <div
            v-if="os.isPhone"
            class="downBtn iosDownBtn"
            @click.stop="getApkInfo('ios', $event)"
          ></div>
          <div
            v-else
            class="downBtn androidDownBtn"
            @click.stop="getApkInfo('android', $event)"
          ></div>
          <div
            v-if="
              !os.isPhone &&
                switchData.androidDownUrl &&
                switchData.channelApkAndDownUrl
            "
            class="downBtn alternateDownloadBtn"
            @click.stop="getApkInfo('androidSpare', $event)"
          ></div>
        </div>
        <div class="bottomTip"></div>
      </div>
    </div>

    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="appName">两年半</div>
          <div class="desc">全免费 更丰富 更高清</div>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">请使用Safari浏览器进行下载</div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";

export default {
  props: ["os", "configs", "switchData", "version", "ip"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,

      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs: {
      immediate: true,
      handler(newValue) {
        this.applyConfigs(newValue || []);
      }
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else if (referrer) {
      this.currUrl = referrer + "user.html";
    } else {
      this.currUrl = window.location.href;
    }
    this.preloadTipImages();
  },
  methods: {
    applyConfigs(configs) {
      this.tgUrl = "";
      this.potatoUrl = "";
      this.swUrl = "";
      this.qdUrl = "";

      configs.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
    },
    preloadTipImages() {
      [
        require("@/assets/images/mobile1/android_tip.png"),
        require("@/assets/images/mobile1/iosTip.png")
      ].forEach(src => {
        const img = new Image();
        img.src = src;
      });
    },
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    checkIsSafari() {
      const ua = this.os.userAgent.toLowerCase();
      // iOS 三方浏览器（Chrome/Firefox/Edge/Opera/夸克）UA 也带 Safari，需排除
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1 &&
        ua.indexOf("crios") === -1 &&
        ua.indexOf("fxios") === -1 &&
        ua.indexOf("edgios") === -1 &&
        ua.indexOf("opios") === -1 &&
        ua.indexOf("quark") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      const click_coordinates_x = event.clientX;
      const click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    toPage(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobilePageB {
  height: 100%;
  width: 100%;
  .pageB {
    width: 100%;
    min-height: 100%;
    height: 100dvh;
    overflow: hidden;
    position: relative;
    background: url("./../../../assets/images/mobile1/pageB/bg.webp") no-repeat
      center top;
    background-size: cover;
    display: flex;
    flex-direction: column;

    .header {
      display: flex;
      padding: 6px 10px 0;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      top: env(safe-area-inset-top);
      left: 0;
      right: 0;
      z-index: 120;
      box-sizing: border-box;
    }
    .logo {
      height: 32px;
      width: auto;
      object-fit: contain;
    }
    .contactBox {
      display: flex;
      gap: 5px;
      .contactItem {
        height: 19px;
        width: auto;
        cursor: pointer;
      }
    }

    .slogan {
      position: absolute;
      left: 15px;
      top: 64%;
      width: 345px;
      height: auto;
      z-index: 10;
      pointer-events: none;
    }

    .bottomBox {
      z-index: 100;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      padding-bottom: env(safe-area-inset-bottom);
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .btnGroup {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 18px;
        margin-bottom: 6px;
      }
      .downBtn {
        width: 120px;
        height: 36px;
        cursor: pointer;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .androidDownBtn {
        background-image: url("./../../../assets/images/mobile1/pageB/androidDownBtn.png");
      }
      .iosDownBtn {
        background-image: url("./../../../assets/images/mobile1/pageB/iosDownBtn.png");
      }
      .alternateDownloadBtn {
        background-image: url("./../../../assets/images/mobile1/pageB/alternateDownloadBtn.png");
      }
      .bottomTip {
        width: 375px;
        height: 36px;
        background: url("./../../../assets/images/mobile1/pageB/tip.png")
          no-repeat center;
        background-size: contain;
        margin-bottom: 4px;
      }
    }
  }

  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/android_tip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }

  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.png") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      position: relative;

      .appName {
        font-size: 10px;
        font-weight: 500;
        color: #242423;
        position: absolute;
        left: 79px;
        bottom: 102px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .desc {
        font-size: 7px;
        font-weight: 500;
        color: #8f908f;
        position: absolute;
        left: 79px;
        bottom: 92px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
